import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import nets from 'nets'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import lodashget from 'lodash/get';
import { getCoreHTTPHeaders } from './headers';
/**
 * @typedef HttpClient
 * @type {object}
 * @property {function} fetch - Make an HTTP request.
 * @property {function} setKountSessionID
 * @property {function} setReferringClientID
 * @property {function} setUserLoggedIn
 * @property {function} setUserLoggedOut
 */

/**
 * Return an instance of HttpClient.
 *
 * HttpClient is a library for making calls to NW-API services.
 *
 * @param {object} config
 * @param {string} config.applicationID - Your FE app's unique application id, used to set a header.
 * @param {string} config.clientID - Your FE app's unique client id, used to set a header.
 * @param {boolean} [config.enableHeadersAndMeta]
 * @param {function} [config.getBrowserSessionIdOverride] - Custom browser id access logic.
 * @param {function} [config.getCookieIdOverride] - Custom cookie id access logic.
 * @param {function} [config.getCookies] - Custom cookie access logic.
 * @param {function} [config.getPageviewId] - Custom hook to get pageview id, used to set X-Pageview-ID header.
 * @param {function} [config.getUrl] - Custom hook to get current url, used to set X-Originating-Url header.
 * @param {function} [config.uuid] - Custom hook to get uuid.
 * @param {object}  config.nets - An instance of nets library.
 * @param {object} [config.nwa] - An instance of @nerdwallet/nwa.
 * @param {integer} [config.xhrTimeout] - Default timeout (milliseconds). Can be overridden on call to fetch().
 *
 * @return {HttpClient}
 */

var createNewHttpClient = function createNewHttpClient(config) {
  var DEFAULT_TIMEOUT = 5000; // milliseconds
  // ---- Config ----

  var nets = config.nets,
      nwa = config.nwa,
      xhrTimeout = config.xhrTimeout; // ---- Internal State ----

  var kountSessionID;
  var referringClientID; // ---- Interface ----

  /**
   * Set kount session ID.
   *
   * Kount is a risk assessment vendor used by the NW Anti-Fraud Service.  It requires clients to provide their
   * frontend SDKs with a "session ID" value that has very specific semantics (similar to SESSION_START_EVENT on mobile),
   * and which must then also be provided by AFS to Kount as part of risk assessments.
   * Providing sticky state on the http client allows clients to simply handle Kount SDK and API propagation in one place.
   *
   * @param {string} id
   */

  function setKountSessionID(id) {
    kountSessionID = id;
  }
  /**
   * Set referring client ID.
   *
   * A referring client ID is optional if this client is making a request on the behalf of another client.
   *
   * @param {string} id
   */


  function setReferringClientID(id) {
    referringClientID = id;
  }
  /**
   * Update NWA metadata to track that a user is logged in.
   */


  function setUserLoggedIn() {
    if (nwa) {
      nwa.setUserProp('gaUserAuthenticationState', 'logged_in');
    }
  }
  /**
   * Update NWA metadata to track that a user is logged out.
   */


  function setUserLoggedOut() {
    if (nwa) {
      nwa.setUserProp('gaUserAuthenticationState', 'logged_out');
    }
  }
  /**
   * Make an HTTP request. (MAIN FUNCTION)
   *
   * If rendering server-side, pass in the current request object as args.serverRequest.
   *
   * @async
   *
   * @param {object} args
   * @param {object} [args.body] - Anything that can be passed to xhr.send. If `json` param is set, this will be overriden.
   * @param {object} [args.cookies={}] - Additional cookies to be included in the request.
   *    These cookies will overwrite any cookies passed through the header argument.
   *    These cookies will be escaped prior to making the request.
   * @param {boolean} [args.followRedirect] - Accept followRedirect arg. This works server side only (node request).
   * @param {object} [args.headers={}] - Request headers.
   * @param {object} [args.json] - JSON request body (overrides `body` param if set).
   * @param {string} args.method - HTTP verb of request (GET|POST|PUT|DELETE).
   * @param {object} [args.params={}] - Request query parameters.
   * @param {Request} [args.serverRequest] - Current request if rendering server-side.
   * @param {integer} [args.timeout] - Request timeout in milliseconds.
   * @param {string} args.url - Request URL not including query params.
   *
   * @return {Promise<object>} - Promise resolves with {response, body} on successful HTTP response.
   *    Rejects with an Error if a request was made and nets returns an error, or response failed to be parsed.
   *    Error will have response and body if they exist (for ServiceSDK backwards compatability).
   */


  function fetch(_x) {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(args) {
      var netsConfig, body, followRedirect, method, serverRequest, url, json, headers, cookies, params, timeout, queryParams, context, coreHeaders, _ref, response, responseBody, parseError;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              netsConfig = {};
              body = args.body, followRedirect = args.followRedirect, method = args.method, serverRequest = args.serverRequest, url = args.url;
              json = args.json;
              headers = args.headers || {};
              cookies = args.cookies || {};
              params = args.params || {};
              timeout = args.timeout || xhrTimeout || DEFAULT_TIMEOUT;
              queryParams = encodeQueryParams(params); // Only tack on question mark if query params are present

              queryParams = queryParams ? "?".concat(queryParams) : ''; // For GET/HEAD requests, use `json: true`, which instructs
              // nets/requests/xhr to expect a JSON response but does not send a request
              // body. For other requests, set `json: {}`, which will also default to a
              // empty object as the request body. This is because nw_api requires a
              // valid json request body even if there are no inputs. Ideally SDKs would
              // should explicitly pass in {} as input when this is needed, but too many
              // existing SDKs rely on the behavior here.

              if (typeof body === 'undefined' && typeof json === 'undefined') {
                if (method === 'GET' || method === 'HEAD') {
                  json = true;
                } else {
                  json = {};
                }
              } // Basic request config.


              netsConfig = {
                method: method,
                url: url + queryParams,
                followRedirect: followRedirect,
                timeout: timeout,
                withCredentials: true,
                body: body
              };

              if (typeof json !== 'undefined') {
                netsConfig.json = json;
              }

              context = {
                url: url,
                config: config,
                serverRequest: serverRequest,
                cookies: cookies,
                referringClientID: referringClientID,
                kountSessionID: kountSessionID
              }; // Get all headers, including cookies

              _context.next = 15;
              return getCoreHTTPHeaders(context);

            case 15:
              coreHeaders = _context.sent;
              netsConfig.headers = _objectSpread({}, headers, coreHeaders);
              _context.next = 19;
              return netsPromisified(nets, netsConfig);

            case 19:
              _ref = _context.sent;
              response = _ref.response;
              responseBody = _ref.body;

              // 401 sometimes implies that a user is unauthenticated and we need to update our tracking accordingly
              // TODO: Revisit when we have error codes (PIE-1108)
              if (response && response.statusCode === 401 && lodashget(responseBody, 'error.data.user_is_logged_out')) {
                setUserLoggedOut();
              } // The underlying 'request' (github.com/request/request) node module will attempt to
              // JSON.parse the response body, but won't do anything if it fails to parse.
              // If the response contains a Content-Type header of application/json, but request failed to
              // parse the result into an object, then we can assume that this is unexpected and should
              // therefore reject with an error
              // Lee: added a check to ignore HTTP 204: No content as... its no content.


              if (!(response && response.headers['content-type'] === 'application/json' && response.statusCode !== 204 && didFailToParse(responseBody))) {
                _context.next = 28;
                break;
              }

              parseError = new Error('Failed to JSON.parse body');
              parseError.response = response;
              parseError.body = responseBody;
              throw parseError;

            case 28:
              return _context.abrupt("return", {
                response: response,
                body: responseBody
              });

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _fetch.apply(this, arguments);
  }

  return {
    fetch: fetch,
    setKountSessionID: setKountSessionID,
    setReferringClientID: setReferringClientID,
    setUserLoggedIn: setUserLoggedIn,
    setUserLoggedOut: setUserLoggedOut
  };
};
/**
 * Helpers
 */
// Encode a params object to URL query string parameters.


function encodeQueryParams(params) {
  var encodedPairs = []; // eslint-disable-next-line no-restricted-syntax

  for (var k in params) {
    encodedPairs.push("".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(params[k])));
  }

  return encodedPairs.join('&');
}

function didFailToParse(body) {
  if (typeof window !== 'undefined') {
    // In the case of the browser, the request module will leave the body as a string.
    // (assuming the config.json option is set)
    return _typeof(body) !== 'object';
  }

  if (typeof Buffer !== 'undefined') {
    // In the case of node.js it leaves the data object as a utf8 encoded Buffer object.
    return body instanceof Buffer;
  }
}

function getNWA() {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line jsx-control-statements/jsx-jcs-no-undef -- directive added automatically by Shepherd migration
    return window.nwa;
  }
} // Wraps nets so it returns a Promise


function netsPromisified(nets, config) {
  return new Promise(function (resolve, reject) {
    nets(config, function (err, response, body) {
      if (err) {
        // Attach response and body to the err so caller can see the response
        err.response = response;
        err.body = body;
        reject(err);
      } else {
        resolve({
          response: response,
          body: body
        });
      }
    });
  });
}

export default function (configArg) {
  if (!configArg || _typeof(configArg) !== 'object') {
    throw new Error('config is required');
  }

  var config = _objectSpread({
    nets: nets,
    nwa: getNWA()
  }, configArg);

  return createNewHttpClient(config);
}